<template>
  <div class="contact">
    <header-main class="anchored"></header-main>
    <nav-mobile></nav-mobile>
    <section id="contact">
      <header class="subpage">
        <h3>Kontakt</h3>
        <h4>Zapraszamy do kontaktu</h4>
      </header>
      <div class="wrapper">
        <!-- <div class="loader" v-if="loading">
          <div>
            <Loader />
          </div>
        </div> -->
        <div class="flex">
          <div class="form1">
            <div class="input-container" title="Imię i nazwisko">
              <div class="input-box">
                <input class="data" type="text" :class="{ error: validFormValues[0].value == 1 }" placeholder="Imię i nazwisko *" v-model="nameAndSurname">
                <i class="material-icons" v-if="validFormValues[0].value == 1">close</i>
              </div>
              <p v-if="validFormValues[0].value == 1">{{ validFormValues[0].text }}</p>
            </div>
            <div class="input-container" title="Adres email">
              <div class="input-box">
                <input class="data" type="text" :class="{ error: validFormValues[1].value == 1 }" placeholder="Adres email *" v-model="email">
                <i class="material-icons" v-if="validFormValues[1].value == 1">close</i>
              </div>
              <p v-if="validFormValues[1].value == 1">{{ validFormValues[1].text }}</p>
            </div>
            <div class="input-container" title="Temat">
              <div class="input-box">
                <input class="data" type="text" :class="{ error: validFormValues[2].value == 1 }" placeholder="Temat *" v-model="subject">
                <i class="material-icons" v-if="validFormValues[2].value == 1">close</i>
              </div>
              <p v-if="validFormValues[2].value == 1">{{ validFormValues[2].text }}</p>
            </div>
            <div class="input-container" title="Numer telefonu">
              <div class="input-box">
                <input class="data" type="text" :class="{ error: validFormValues[4].value == 1 }" placeholder="Numer telefonu" v-model="phone">
                <i class="material-icons" v-if="validFormValues[4].value == 1">close</i>
              </div>
              <p v-if="validFormValues[4].value == 1">{{ validFormValues[4].text }}</p>
            </div>
          </div>
          <div class="box">
            <div class="info">
              <h5>AFK Centrum Obsługi Biznesu Sp. z o.o.</h5>
              <div class="segment">
                <i class="material-icons">place</i>
                <ul>
                  <li>ul. Świeradowska 51-57 , 50-559 Wrocław</li>
                  <li>dzielnica Wrocław Krzyki Gaj</li>
                  <li>I piętro Centrum Handlowe Ferio Gaj</li>
                </ul>
              </div>
              <div class="flex2">
                <div class="column">
                  <div class="segment">
                    <i class="material-icons">smartphone</i>
                    <ul>
                      <li><a href="tel:+48713369521">+48 71 336 95 21</a></li>
                    </ul>
                  </div>
                  <div class="segment">
                    <i class="material-icons">email</i>
                    <ul>
                     <li><a href="mailto:bok@afkcob.pl">bok@afkcob.pl</a></li>
                    </ul>
                  </div>
                </div>
                <div class="column">
                  <div class="segment">
                    <i class="material-icons">access_time</i>
                    <ul>
                      <li>poniedziałek – piątek 8:00-16:00</li>
                    </ul>
                  </div>
                  <div class="flex3">
                    <div class="segment">
                      <i class="material-icons">directions_railway</i>
                      <ul>
                        <li>31, 32</li>
                      </ul>
                    </div>
                    <div class="segment">
                      <i class="material-icons">directions_bus</i>
                      <ul>
                        <li>136, 145, K</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form2">
          <div class="input-container" title="Treść">
            <div class="input-box">
              <textarea class="data" placeholder="Treść *" :class="{ error: validFormValues[3].value == 1 }" v-model="content"></textarea>
              <i class="material-icons" v-if="validFormValues[3].value == 1">close</i>
            </div>
            <p v-if="validFormValues[3].value == 1">{{ validFormValues[3].text }}</p>
          </div>
        </div>
        <div class="loader" v-if="loading">
          <div>
            <Loader />
          </div>
        </div>
        <button class="default" v-if="!loading" @click="sendMessage()">Wyślij</button>
      </div>
      <div id="map">
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2506.7609591061523!2d17.039903415754132!3d51.07596257956649!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x470fc2f9ae63608d%3A0xa80ec26f8880e6d0!2sAFK%20Centrum%20Obs%C5%82ugi%20Biznesu!5e0!3m2!1spl!2spl!4v1588536087966!5m2!1spl!2spl" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
      </div>
    </section>
    <footer-main></footer-main>
  </div>
</template>

<script>
import HeaderMain from '@/components/HeaderMain.vue'
import NavMobile from '@/components/NavMobile.vue'
import FooterMain from '@/components/FooterMain.vue'
import validation from '../functions/validation';
import Loader from '../components/Loader';

export default {
  name: 'Contact',
  components: {
    HeaderMain,
    NavMobile,
    FooterMain,
    Loader,
  },
  data() {
    return {
      nameAndSurname: '',
      email: '',
      subject: '',
      content: '',
      phone: '',
      validFormValues: new Array(5).fill(0).map(() => ({ value: 0, text: 'Podana wartość jest nieprawidłowa', })),
      loading: 0,
    }
  },
  methods: {
    async sendMessage() {
      this.validateForm();
      if(this.validFormValues.filter(element => element.value == 1).length > 0) {
        this.toggleAlert(0, 'Poprawnie wypełnij pola');
        return;
      } else {
        let payload = {
          nameAndSurname: this.nameAndSurname,
          email: this.email,
          subject: this.subject,
          content: this.content,
          phone: this.phone,
          serviceType: 1
        };
        this.loading = 1;
        await this.axios
        .post(this.api + 'contact', payload)
        .then(response => {
          if(response.data.status == 1) {
            this.toggleAlert(1, response.data.msg);
            this.nameAndSurname = '';
            this.email = '';
            this.subject = '';
            this.content = '';
            this.phone = '';
            this.loading = 0;
          } else {
            this.toggleAlert(0, response.data.msg);
            this.loading = 0;
          };
        })
        .catch(error => {
          if(error.response) {
            if(error.response.data) {
              this.toggleAlert(0, error.response.data.msg);
              this.loading = 0;
            };
          };
        });
      };
    },
    validateForm() {
      this.validFormValues[0] = validation.validateString(this.nameAndSurname, this.validFormValues[0], 50);
      this.validFormValues[1] = validation.validateEmail(this.email, this.validFormValues[1]);
      this.validFormValues[2] = validation.validateString(this.subject, this.validFormValues[2], 50);
      this.validFormValues[3] = validation.validateString(this.content, this.validFormValues[3], 1000);
      this.validFormValues[4] = validation.validateNonRequiredPhoneNumber(this.phone, this.validFormValues[4]);
    },
    toggleAlert(type, msg) {
      this.$store.commit('toggleAlert', {
        visibility: 1,
        type: type,
        msg: msg
      });
    },
  },
  computed: {
    api(){
      return this.$store.state.api;
    },
  },
}
</script>
<style scoped lang="scss">
  section#contact { overflow: hidden; }
  section#contact div.wrapper { width: 1000px; margin: 60px auto; }
  section#contact div.flex { display: flex; flex-wrap: wrap; justify-content: space-between; margin-bottom: 10px; }
  section#contact div.form1 { width: 350px; }
  section#contact div.form1 div.input-container { margin-bottom: 20px; }
  section#contact div.form1 div.input-container div.input-box { width: 350px; height: 50px;}
  section#contact div.form1 div.input-container div.input-box input { width: 350px; height: 50px; }
  section#contact div.form2 { margin: 0 0 20px 0; }
  section#contact div.form2 div.input-container div.input-box { width: 100%; height: 300px; }
  section#contact div.form2 div.input-container div.input-box textarea { width: 100%; height: 300px; }
  section#contact div.form2 div.input-container div.input-box textarea.error { border: 1px solid $fontRed; }
  section#contact div.box { display: flex; flex-wrap: wrap; justify-content: space-between; align-items: center; width: 620px; height: 260px; padding: 10px 30px; border-radius: 5px; 
    background: rgba(228, 228, 230, 1);  }
  section#contact div.box div.info { width: 100%; }
  section#contact div.box div.flex2 { display: flex; justify-content: space-between; width: 100%; }
  section#contact div.box div.flex3 { display: flex; }
  section#contact div.box div.flex2 div.column:nth-child(2) { margin-left: 30px; }
  section#contact div.box div.column div.flex3 div.segment { margin-top: 0; }
  section#contact div.box div.flex3 > div.segment:nth-child(2) { margin-left: 30px; }
  section#contact div.box h5 { margin: 0 0 0 35px; padding: 0; color: $fontBlack; font-weight: 500; font-size: 16px; }
  section#contact div.box div.segment { display: flex; margin: 10px 0; }
  section#contact div.box div.segment i.material-icons { display: block; color: $orangeDark; font-size: 21px; }
  section#contact div.box div.segment ul { margin: 0 0 0 15px; padding: 0; list-style: none; }
  section#contact div.box div.segment ul li { margin: 0 0 5px 0; color: $fontBlack; font-size: 14px; }
  section#contact div.box div.segment ul li a { color: $fontBlack; }
  section#contact div.box div.segment ul li a:hover { text-decoration: underline; }

  section#contact div#map { margin: 0 0 -7px 0; opacity: 0.7; z-index: 1; position: relative; }
  section#contact div#map:hover { opacity: 1; }
  section#contact div#map iframe { width: 100%; height: 450px; margin: 0; padding: 0; }
  // section#contact div.wrapper div.loader { display: flex; justify-content: center; align-items: center; background-color: rgba(0, 0, 0, 0.03); z-index: 2; position: fixed; height: 100vh; width: 100vw; top: 50%; left: 50%; transform: translate(-50%, -50%); }
  // section#contact div.wrapper div.loader div { display: inline-block; height: 40px; width: 40px; }
  section#contact div.wrapper div.loader { display: flex; justify-content: center; align-items: center; z-index: 2; }
  section#contact div.wrapper div.loader div { display: inline-block; height: 40px; width: 40px; }
  section#contact div.input-container div.input-box i.material-icons { top: 18px; }

  @media (max-width: 1040px) {
    section#contact div.wrapper { width: 100vw; margin: 0; }
    section#contact div.form1 { order: 2; }
    section#contact div.form1 div.input-container { margin: 20px; }
    section#contact div.form2 div.input-container div.input-box { width: calc(100vw - 40px); margin: 20px; }
    section#contact div.box { width: calc(100vw - 40px); margin: 20px 20px 0 20px; order: 1; }
    button.default { margin: 0 20px; }

    section#contact div#map { margin: 20px; border-radius: 7px; }
    section#contact div#map iframe { border-radius: 7px; }
    section#contact div#map iframe { height: 300px; }
  }

  @media (max-width: 600px) {
    section#contact div.flex { margin: 0; }
    section#contact div.form1 div.input-container div.input-box input { width: calc(100vw - 40px);  }
    section#contact div.box { height: initial; }
    section#contact div.box div.flex2 { flex-wrap: wrap; }
    section#contact div.box div.flex2 div.column:nth-child(2) { margin-left: 0px; }
    section#contact div.form2 div.input-container div.input-box { margin: 0 20px 20px 20px; }
  }
</style>
